// extracted by mini-css-extract-plugin
export default {"dragndropWrapper":"DropArea_dragndropWrapper__TN2jt"};